import gql from 'graphql-tag';

const collegeEventFilterFragment = gql`
  fragment CollegeEventFilter on CollegeEventFilter {
    id
    genders
    distanceUnit
    distanceValue
    postalCode
    ethnicities
    gradeLevels
    gpaScores
    name
    version
  }
`;

export default collegeEventFilterFragment;
